<template>
    <toggle-button
        name="switch"
        :value="value"
        :labels="messages"
        :width="width"
        :color="colors"
        sync
        @change="onInput"
    />
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';
import { propValidator } from '@/utils/validators';

export default {
    name: 'toggle',
    components: { ToggleButton },

    props: {
        colors: {
            type: Object,
            default: () => ({ checked: '#2e8472', unchecked: '#e6576a' }),
        },

        messages: {
            type: Object,
            default: () => ({ checked: 'On', unchecked: 'Off' }),

            validator(value) {
                return propValidator(value, {
                    checked: String,
                    unchecked: String,
                });
            },
        },

        value: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            width: 60,
        };
    },

    mounted() {
        const { checked, unchecked } = this.messages;
        const checkedMsg = checked || '';
        const uncheckedMsg = unchecked || '';
        const numLetters = Math.max(checkedMsg.length, uncheckedMsg.length);
        const widthIncrease = (numLetters - 3) * 5;

        this.width = 65 + widthIncrease;
    },

    methods: {
        onInput(e) {
            this.$emit('input', e.value);
        },
    },
};
</script>

<style lang="scss">
.vue-js-switch {
    align-self: flex-start;
}
</style>
